import ApplicationController from "./application_controller";

export default class LanguageDropdownController extends ApplicationController {
  static targets = ["trigger", "menu"];

  declare triggerTarget: HTMLElement;
  declare menuTarget: HTMLElement;

  connect() {
    this.boundClose = this.close.bind(this);
  }

  toggle() {
    const isOpen = this.menuTarget.classList.toggle("is-active");
    this.triggerTarget.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) {
      document.addEventListener("click", this.boundClose);
    } else {
      document.removeEventListener("click", this.boundClose);
    }
  }

  close(event?: Event) {
    if (
      event &&
      (this.triggerTarget.contains(event.target as Node) ||
        this.menuTarget.contains(event.target as Node))
    ) {
      return;
    }
    this.menuTarget.classList.remove("is-active");
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.boundClose);
  }

  private boundClose: (e: Event) => void;
}
